import Navlink from "../../component/navlink/Navlink";

const Portfolio = ({ children }) => {
  return (
    <>
      <Navlink />
      {children}
    </>
  );
};

export default Portfolio;
